import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Shown when a request fails at the network/server level. The page is only reloaded when
 * the user asks for it: an automatic reload while a payment call is still being processed
 * server side can lead to the charge being attempted twice.
 */
@Component({
  selector: 'app-something-went-wrong-modal',
  standalone: true,
  templateUrl: './something-went-wrong-modal.component.html',
  styleUrl: './something-went-wrong-modal.component.scss'
})
export class SomethingWentWrongModalComponent {

  constructor(public bsModalRef: BsModalRef) { }

  reload() {
    window.location.reload();
  }
}
